import {AsyncInlineError, tracer} from '@s-ui/decorators'
import {UseCase} from '@s-ui/domain'

import UserRepositoriesFactory from '../Repositories/factory.js'

/**
 * Use case to check if a user with the given email already exists
 */
class CheckUserEmailExistsUserUseCase extends UseCase {
  #repository

  constructor({repository}) {
    super()
    this.#repository = repository
  }

  /**
   * Static factory method
   * @param {Object} params
   * @param {Object} params.config
   * @returns {CheckUserEmailExistsUserUseCase}
   */
  static create({config}) {
    return new CheckUserEmailExistsUserUseCase({
      repository: UserRepositoriesFactory.httpUserRepository({config})
    })
  }

  /**
   * Execute the use case
   * @param {Object} params
   * @param {string} params.email
   * @returns {Promise<{exists: boolean}>}
   */
  @tracer({metric: 'CheckUserEmailExistsUserUseCase#execute'})
  @AsyncInlineError()
  async execute({email}) {
    const [error, result] = await this.#repository.checkUserEmailExists({email})

    if (error) return Promise.reject(error)

    return result.toJSON()
  }
}

export const factory = CheckUserEmailExistsUserUseCase.create
